import api from "./api"

export const getStockAudits = async () => {
  const response = await api.get("/stock-audits")
  return response.data
}

export const getStockAuditById = async (id) => {
  const response = await api.get(`/stock-audits/${id}`)
  return response.data
}

export const createStockAudit = async (payload) => {
  const response = await api.post("/stock-audits", payload)
  return response.data
}

export const updateStockAudit = async (id, payload) => {
  const response = await api.put(`/stock-audits/${id}`, payload)
  return response.data
}

export const deleteStockAudit = async (id) => {
  const response = await api.delete(`/stock-audits/${id}`)
  return response.data
}

export const getStockAuditFormData = async () => {
  const response = await api.get("/stock-audits/form-data")
  return response.data
}

export const getStockAuditItems = async (auditId) => {
  const response = await api.get(`/stock-audits/${auditId}/items`)
  return response.data
}

export const updateStockAuditItems = async (auditId, payload) => {
  const response = await api.put(`/stock-audits/${auditId}/items`, payload)
  return response.data
}

export const validateStockAudit = async (auditId, payload) => {
  const response = await api.post(`/stock-audits/${auditId}/validate`, payload)
  return response.data
}